import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { publicAxios } from "../axiosInstances";

const updateInvitationStatus = async (invitationId: string) => {
  try {
    const res = await publicAxios.post(`/visitor/update-invitation-status`, {
      invitationId,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        ...error,
        message: error.response?.data.message,
      };
    }

    throw error;
  }
};

export const useUpdateInvitationStatus = () => {
  return useMutation({
    mutationFn: updateInvitationStatus,
  });
};

const refuseParticipation = async (invitationId: string) => {
  try {
    const res = await publicAxios.post(`/visitor/refuse-participation`, {
      invitationId,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        ...error,
        message: error.response?.data.message,
      };
    }

    throw error;
  }
};

export const useRefuseParticipation = () => {
  return useMutation({
    mutationFn: refuseParticipation,
  });
};
